/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SuperUserControllerService {
    /**
     * @returns any Return value of SuperUserController.getAllFeedbacks
     * @throws ApiError
     */
    public static superUserControllerGetAllFeedbacks(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v0/api/get-all-feedbacks',
        });
    }
    /**
     * @returns any Return value of SuperUserController.getAllProperties
     * @throws ApiError
     */
    public static superUserControllerGetAllProperties(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v0/api/get-all-properties',
        });
    }
    /**
     * @returns any Return value of SuperUserController.getAllUsers
     * @throws ApiError
     */
    public static superUserControllerGetAllUsers(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v0/api/get-all-users',
        });
    }
}
